import { FunctionComponent, useMemo } from 'react'
import { ReactComponent as ArrowIcon } from '@/assets/icon_arrow_right_24.svg'
import { TabScrollButtonProps } from './types'
import useStyles from './styles'
import { isDirection } from './utils'

const DEFAULT_DIRECTION = 'right'

export const TabScrollButton: FunctionComponent<TabScrollButtonProps> = ({
  direction: propDirection = DEFAULT_DIRECTION,
  styles: overrides,
  buttonProps = {},
  ...rest
}) => {
  const direction = useMemo(
    () => (isDirection(propDirection) ? propDirection : DEFAULT_DIRECTION),
    [propDirection],
  )

  const styles: typeof overrides = useStyles({ isLeft: direction === 'left' })

  return (
    <button css={[styles.root, overrides?.root]} {...rest} {...buttonProps}>
      <ArrowIcon css={[styles.icon, overrides?.icon]} />
    </button>
  )
}
